import { render, staticRenderFns } from "./DigitCouples.vue?vue&type=template&id=68f6cc7a&lang=pug&"
import script from "./DigitCouples.vue?vue&type=script&lang=js&"
export * from "./DigitCouples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports